/* eslint-disable react/jsx-no-target-blank */
import {useEffect} from 'react'
import {ILayout, useLayout} from '../../core'

const Footer = () => {
  const {config} = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  return (
    <>
      <div className='text-dark order-2 order-md-1'>
        <span className='text-muted fw-semibold'>
          © 2017-2026 TEACH | Con tecnología de {' '}
          <a
            href='https://topo.ar'
            target='_blank'
            className='text-gray-800 text-hover-primary'
          >
            TOPO.ar
          </a>
          {' '} para {' '}
          <a
            href='http://institutoalcorta.edu.ar/'
            target='_blank'
            className='text-gray-800 text-hover-primary'
          >
            Instituto Alcorta
          </a>
        </span>
      </div>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
